import { SquarePen, View, FilePlus2 } from "lucide-react";
import React from "react";
import { DOCUMENT_TYPES } from "../config/DocumentConfig";

const ModeIndicator = ({ mode, documentType, leadNumber }) => {
  // console.log("Mode Indicator", mode, documentType, leadNumber);
  const isEditMode = mode === "edit";
  const isQuotationFromLead =
    mode === "new" &&
    documentType?.toUpperCase() === DOCUMENT_TYPES.QUOTATION &&
    !!leadNumber;
  // console.log("Is quotation from lead", isQuotationFromLead);

  // Don't render for new mode unless it's a quotation from lead
  if (mode === "new" && !isQuotationFromLead) return null;

  return (
    <div className="fixed top-16 left-1/2 -translate-x-1/2 z-20 transition-all duration-300 hover:scale-105">
      <div className="relative bg-white rounded-xl rounded-tr-none shadow-xl border border-gray-100 px-3 py-2 min-w-40">
        <div className="absolute -top-1 -right-1">
          <div className="relative w-3 h-3">
            <div
              className={`absolute inset-0 rounded-full animate-ping opacity-75 ${
                isEditMode
                  ? "bg-orange-500"
                  : isQuotationFromLead
                  ? "bg-blue-500"
                  : "bg-green-500"
              }`}
            ></div>
            <div
              className={`relative w-3 h-3 rounded-full ${
                isEditMode
                  ? "bg-orange-500"
                  : isQuotationFromLead
                  ? "bg-blue-500"
                  : "bg-green-500"
              }`}
            ></div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div
            className={`p-2 rounded-lg ${
              isEditMode
                ? "bg-orange-100"
                : isQuotationFromLead
                ? "bg-blue-100"
                : "bg-green-100"
            }`}
          >
            {isEditMode ? (
              <SquarePen className="w-5 h-5 text-orange-600" />
            ) : isQuotationFromLead ? (
              <FilePlus2 className="w-5 h-5 text-blue-600" />
            ) : (
              <View className="w-5 h-5 text-green-600" />
            )}
          </div>

          <div className="flex flex-col">
            {isQuotationFromLead ? (
              <>
                <span className="font-semibold text-gray-900 text-sm leading-tight">
                  Quotation Creation
                </span>
                <span className="text-xs text-gray-500 font-medium">
                  Converted from Lead{" "}
                  <span className=" font-bold text-black">#{leadNumber}</span>
                </span>
              </>
            ) : (
              <>
                <span className="font-semibold text-gray-900 text-sm leading-tight">
                  {isEditMode ? "Edit Mode" : "View Mode"}
                </span>
                <span className="text-xs text-gray-500 font-medium">
                  {isEditMode ? "Make changes" : "Read-only"}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModeIndicator;
